import React from "react";
import { Outlet } from "react-router-dom";


/** Default NavHeader layout for pages */
const RootTemplate = () => {
  return (
    <>          
      <div >
        <main>         
          <div >
            <Outlet />
          </div>
        </main>
      </div>
    </>
  );
};

export default RootTemplate;
